import { useCallback, useState } from "react";

import { message } from "antd";

import { useGetPlaidLinkTokenMutation } from "../../services/connectBankAccount";
import { IUser } from "../../types/auth";
import { logError } from "../../utils/sentry";

export const useBankConnection = ({
    user,
    connectedBankAccountsLength,
    setInitialBankCount,
}: {
  user: IUser;
  connectedBankAccountsLength: number;
  setInitialBankCount: (_count: number) => void;
}) => {
    const [getLinkToken] = useGetPlaidLinkTokenMutation();

    const [linkToken, setLinkToken] = useState<string | undefined>();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [bankConnecting, setBankConnecting] = useState(false);

    const openConnectModal = useCallback(async () => {
        try {
            setBankConnecting(true);
            setInitialBankCount(connectedBankAccountsLength || 0);

            const { data } = await getLinkToken({}) as any;
            const token = data?.response?.link_token;

            if (token) {
                setLinkToken(token);
                setIsModalOpen(true);
            } else {
                logError("[Plaid Link] Missing link token in response.");
                message.error("Unable to generate link token");
            }
        } catch (error: any) {
            logError(error, {
                clientId: user?.id,
                function: "openConnectModal",
                error: error.message,
            });
            message.error("Something went wrong while connecting the bank.");
        } finally {
            setBankConnecting(false);
        }
    }, [getLinkToken, connectedBankAccountsLength, user?.id, setInitialBankCount]);

    return {
        linkToken,
        isModalOpen,
        bankConnecting,
        setIsModalOpen,
        openConnectModal,
        setBankConnecting,
    };
};
